import translate from '@translate';
import { useCheckPermission } from '../../utils/checkPermission';

export type EditKeysType = 'UID' | 'VALUE' | 'NAME' | 'IMPORT' | 'EXPORT' | 'ID' | 'SAVED';

export const EDIT_KEYS = ['UID', 'VALUE', 'NAME', 'IMPORT', 'EXPORT', 'ID', 'SAVED'];
